import Vue from 'vue';
import VueRouter from 'vue-router';
import Vuelidate from 'vuelidate';
import App from './App';
import VueTheMask from 'vue-the-mask';
import VTooltip from 'v-tooltip';
import Toast from 'vue-toastification';
import "vue-toastification/dist/index.css";
import { languageService } from './service/languageService';
import { initLocale } from './service/setLocaleGlobally';
import { i18n } from '../src/service/i18n';

Vue.config.ignoredElements = ['ion-icon']
Vue.config.ignoredElements = [/^ion-/]

// Default use
Vue.use(VueRouter);
Vue.use(Vuelidate);
Vue.use(VueTheMask);
Vue.use(VTooltip);
Vue.use(Toast, {
  transition: "Vue-Toastification__fade",
  maxToasts: 4,
  newestOnTop: true,
  filterBeforeCreate: (toast, toasts) => {
    if (toasts.filter(
      t => t.type === toast.type
    ).length !== 0) {
      // Returning false discards the toast
      return false;
    }
    // You can modify the toast if you want
    return toast;
  }
})

// Filters
import moment from 'moment'
// moment.locale('pt-br');

Vue.filter('cpfOrCnpj', function (string) {
  if (string) {
    let stringRegex = string.replace(/[^0-9]/g, "");
    switch (stringRegex.length) {
      case 11:
        return stringRegex.substring(0, 3) + "." + stringRegex.substring(3, 6) + "." + stringRegex.substring(6, 9) + "-" + stringRegex.substring(9, 11);
      case 14:
        return stringRegex.substring(0, 2) + "." + stringRegex.substring(2, 5) + "." + stringRegex.substring(5, 8) + "/" + stringRegex.substring(8, 12) + "-" + stringRegex.substring(12, 14);
      default:
        return string;
    }
  }
});

Vue.filter('phone', function (string) {
  if (string) {
    let stringRegex = string.replace(/[^0-9]/g, "");
    switch (stringRegex.length) {
      case 11:
        return `(${stringRegex.substring(0, 2)}) ${stringRegex.substring(2, 7)}-${stringRegex.substring(7, 11)}`;
      case 10:
        return `(${stringRegex.substring(0, 2)}) ${stringRegex.substring(2, 6)}-${stringRegex.substring(6, 10)}`;
      case 9:
        return `${stringRegex.substring(0, 5)}-${stringRegex.substring(5, 9)}`;
      case 8:
        return `${stringRegex.substring(0, 4)}-${stringRegex.substring(4, 8)}`;
      default:
        return string;
    }
  }
});

Vue.filter('limitTo', function (value, limit) {
  if (value) {
    return value.length > limit ? value.substring(0, limit) + '...' : value;
  }
});

Vue.filter('formatName', function (value) {
  if (value) {
    try {
      let name = value.split(" ");
      if (name.length > 1) {
        return name[0].substring(0, 1) + name[1].substring(0, 1);
      } else {
        return name[0].substring(0, 2);
      }
    } catch (e) {
      return value;
    }
  }
});

Vue.filter('formatMoney', function (value) {
  if (value) {
    return value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
  }
});

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY')
  }
});

Vue.filter('formatDateMounth', function (value) {
  if (value) {
    return moment(String(value), "DD/M/YYYY").format('DD/MM/YYYY')
  }
});

Vue.filter('formatDateHours', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY HH:mm')
  }
});

Vue.filter('formatDayMonth', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM')
  }
});

Vue.filter('formatDateHoursSeconds', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY HH:mm:ss')
  }
});

Vue.filter('formatDayMonthHours', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM HH:mm')
  }
});

Vue.filter('formatHours', function (value) {
  if (value) {
    return moment(String(value)).format('HH:mm')
  }
});

Vue.filter('formatFullHours', function (value) {
  if (value) {
    return moment(String(value)).format('HH:mm:ss')
  } else {
    return ''
  }
});

Vue.filter('firstLastName', function (value) {
  if (value) {
    const stringSplit = value.split(" ");

    if (stringSplit.length >= 2) {
      return stringSplit[0].substring(0, 1) + stringSplit[1].substring(0, 1)
    } else {
      return stringSplit[0].substring(0, 2)
    }
  }
  else {
    return ''
  }
});

Vue.filter('strDay', function (value) {
  if (value) {
    return moment(String(value)).format('ddd')
  }
});

Vue.filter('strDayFull', function (value) {
  if (value) {
    return moment(String(value)).format('dddd')
  }
});

Vue.filter('completeStrDayDate', function (value) {
  if (value) {
    return moment(String(value)).format('dddd DD/MM/YYYY')
  }
});

Vue.filter('yearNumber', function (value) {
  if (value) {
    return moment(String(value)).format('YYYY')
  }
});

Vue.filter('dateDay', function (value) {
  if (value) {
    return moment(String(value)).format('DD')
  }
});

Vue.filter('strMonth', function (value) {
  if (value) {
    return moment(String(value)).format('MMM')
  }
});

Vue.filter('strMonthFull', function (value) {
  if (value) {
    return moment(String(value)).format('MMMM')
  }
});

Vue.filter('convertToDayMothYear', (value) => {
  if (value) {
    let year = value.toString().substring(0, 4);
    let month = value.toString().substring(4, 6);
    let day = value.toString().substring(6, 8);

    return day + "/" + month + "/" + year;
  } else {
    return "";
  }
});

import Login from './vue/views/public/login/Login.vue';
import LoginPartner from './vue/views/public/login/LoginPartner.vue';
import Home from './vue/views/restricted/home/home.vue'
import ListPoint from './vue/views/restricted/listPoint/ListPointsV2.vue';
import DetailPoint from './vue/views/restricted/detailPoint/DetailPoint.vue';
import Point from './vue/views/restricted/point/Point.vue';
import newPoint from './vue/views/restricted/point/newPoint.vue'
import Summary from './vue/views/restricted/summary/Summary.vue';
import BalanceHours from './vue/views/restricted/summary/BalanceHours.vue'
import Perfil from './vue/views/restricted/perfil/Perfil.vue';
import MyTeam from './vue/views/restricted/myTeam/MyTeam.vue';
import AdminRegisterPoint from './vue/views/restricted/adminRegisterPoint/adminRegisterPoint.vue';
import RequestAdjustment from './vue/views/restricted/requestAdjustment/requestAdjustment.vue';
import UserPerfil from './vue/views/restricted/userPerfil/userPerfil.vue';
import ShowLocationInMap from './vue/views/restricted/showLocationInMap/showLocationInMap.vue';
import PointControl from './vue/views/restricted/pointControl/pointControl.vue';
import DayDetail from './vue/views/restricted/dayDetail/dayDetail.vue';
import RequestedFit from './vue/views/restricted/requestedFit/requestedFit.vue';
import ListHoliday from './vue/views/restricted/holiday/listHoliday.vue';
import ListHolidayAdmin from './vue/views/restricted/holiday/listHolidayAdmin.vue';
import RequestHoliday from './vue/views/restricted/holiday/requestHoliday.vue';
import DetailHoliday from './vue/views/restricted/holiday/detailHoliday.vue';
import ListFit from './vue/views/restricted/requestedFit/listFit.vue';
import MeListFit from './vue/views/restricted/requestedFit/meListFit.vue';
import MyMirror from './vue/views/restricted/myMirror/myMirror.vue';
import Communication from './vue/views/restricted/communication/communication.vue';
import Feedback from './vue/views/restricted/feedback/feedback.vue';
import CommunicationDetail from './vue/views/restricted/communication/communicationDetail.vue';
import PointHistory from './vue/views/restricted/pointHistory/PointHistory.vue';
import newPointHistory from './vue/views/restricted/pointHistory/newPointHistory.vue'
import ConfirmPoint from './vue/views/restricted/confirmPoint/confirmPoint.vue';
import newConfirmPoint from './vue/views/restricted/confirmPoint/newConfirmPoint.vue'
import Chat from './vue/views/restricted/chat/chat.vue';
import LogHistory from './vue/views/restricted/logHistory/logHistory.vue';
import Refunds from './vue/views/restricted/refunds/refunds.vue';
import Documents from './vue/views/restricted/documents/documentFolders.vue';
import FoldersDetail from './vue/views/restricted/documents/foldersDetail.vue';
import Loading from './vue/views/restricted/loading/loading.vue';
import TermsOfUse from './vue/views/restricted/termsOfUse/TermsOfUse.vue';
import PrivacyPolicies from './vue/views/restricted/privacyPolicies/PrivacyPolicies.vue'
import { REQUEST_SERVICE } from "./requestConfig";
import { UTIL_SERVICE } from "./utils";
// import ptBR from 'vuejs-datepicker/dist/locale/translations/pt-BR';

const accessToV2 = JSON.parse(localStorage.getItem('accessToV2'));

const routes = [
  { path: '/login', component: Login, meta: { allowsLogin: true } },
  { path: '/villafacil', component: LoginPartner, meta: { allowsLogin: true } },
  { path: '/', component: Home, meta: { requiresAuth: true } },
  { path: '/clock-ins', component: newPoint, meta: { requiresAuth: true } },
  { path: '/registro-de-ponto', redirect: '/clock-ins'},
  { path: '/confirmacao-de-ponto', component: newConfirmPoint, meta: { requiresAuth: true } },
  { path: '/clock-in-confirmation', redirect: '/confirmacao-de-ponto' },
  { path: '/clock-in-history', component: newPointHistory, meta: { requiresAuth: true } },
  { path: '/historico-de-ponto', redirect: '/clock-in-history' },
  { path: '/my-solicitations', component: MeListFit, meta: { requiresAuth: true } },
  { path: '/minhas-solicitacoes', redirect: '/my-solicitations' },
  { path: '/log-history', component: LogHistory, meta: { requiresAuth: true } },
  { path: '/historico-de-log', redirect: '/log-history' },
  { path: '/clock-in-details/:idPoint/:type', component: DetailPoint, meta: { requiresAuth: true } },
  { path: '/detalhe-do-ponto/:idPoint/:type', redirect: to => {
    return `/clock-in-details/${to.params.idPoint}/${to.params.type}`
  }},
  { path: '/chat', component: Chat, meta: { requiresAuth: true } },
  { path: '/conversas', redirect: '/chat' },
  { path: '/conversas/:idChat', component: Chat, meta: { requiresAuth: true } },
  { path: '/chat/:idChat', redirect: to => {
    return `/chat/${to.params.idChat}`
  } },
  { path: '/statements', component: Communication, meta: { requiresAuth: true } },
  { path: '/comunicados', redirect: '/statements' },
  { path: '/feedback', component: Feedback, meta: { requiresAuth: true } },
  { path: '/statement-details/:id', component: CommunicationDetail, meta: { requiresAuth: true } },
  { path: '/detalhes-do-comunicado/:id', redirect: to => {
    return `/statement-details/${to.params.id}`
  }},
  { path: '/timecard-mirrors', component: MyMirror, meta: { requiresAuth: true } },
  { path: '/meus-espelhos', redirect: '/timecard-mirrors' },
  { path: '/balance-hours', component: BalanceHours, meta: { requiresAuth: true } },
  { path: '/saldo-de-horas', redirect: '/balance-hours' },
  { path: '/profile', component: Perfil, meta: { requiresAuth: true } },
  { path: '/perfil', redirect: '/profile' },
  { path: '/profile/:routeB/:idUser', component: UserPerfil, meta: { requiresAuth: true } },
  { path: '/perfil/:routeB/:idUser', redirect: to => {
    return `/profile/${to.params.routeB}/${to.params.idUser}`
  } },
  { path: '/day-detail/:routeB/:idDay', component: DayDetail, meta: { requiresAuth: true } },
  { path: '/detalhes-do-dia/:routeB/:idDay', redirect: to => {
    return `/day-detail/${to.params.routeB}/${to.params.idDay}`
  } },
  { path: '/clock-in-management', component: PointControl, meta: { requiresAuth: true } },
  { path: '/gestao-de-ponto', redirect: '/clock-in-management' },
  { path: '/adjustments-solicitations', component: RequestAdjustment, meta: { requiresAuth: true } },
  { path: '/solicitar-ajuste/:idPoint/:type', redirect: to => {
    return `/adjustments-solicitations/${to.params.idPoint}/${to.params.type}`
  } },
  { path: '/clock-in-location', component: ShowLocationInMap, meta: { requiresAuth: true } },
  { path: '/local-do-ponto', redirect: '/clock-in-location' },
  { path: '/clock-in-registers', component: AdminRegisterPoint, meta: { requiresAuth: true } },
  { path: '/registro-de-pontos', redirect: '/clock-in-registers' },
  { path: '/solicitations-list', component: ListFit, meta: { requiresAuth: true } },
  { path: '/lista-de-solicitacao', redirect: '/solicitations-list' },
  { path: '/vacation', component: ListHoliday, meta: { requiresAuth: true } },
  { path: '/lista-de-ferias-afastamento', redirect: '/vacation' },
  { path: '/manage-vacations', component: ListHolidayAdmin, meta: { requiresAuth: true } },
  { path: '/gerenciar-ferias-afastamento', redirect: '/manage-vacations' },
  { path: '/solicitacao-de-ferias-afastamento', component: RequestHoliday, meta: { requiresAuth: true } },
  { path: '/vacation-details/:idRequest', component: DetailHoliday, meta: { requiresAuth: true } },
  { path: '/detalhes-da-ferias-afastamento/:idRequest', redirect: to => {
    return `/vacation-details/${to.params.idRequest}`
  } },
  { path: '/vacation-details/:idRequest/:returnType', component: DetailHoliday, meta: { requiresAuth: true } },
  { path: '/detalhes-da-ferias-afastamento/:idRequest', redirect: to => {
    return `/vacation-details/${to.params.idRequest}/${to.params.returnType}`
  } },
  { path: '/solicited-adjustment/:idSolicitation', component: RequestedFit, meta: { requiresAuth: true } },
  { path: '/verificar-ajuste-solicitado/:idSolicitation', redirect: to => {
    return `/solicited-adjustment/${to.params.idSolicitation}`
  } },
  { path: '/refund', component: Refunds, meta: { requiresAuth: true } },
  { path: '/reembolsos', redirect: '/refund' },
  { path: '/documents', component: Documents, meta: { requiresAuth: true }},
  { path: '/documentos', redirect: '/documents' },
  { path: '/folder-details/:folderId', component: FoldersDetail, meta: { requiresAuth: true } },
  { path: '/detalhes-da-pasta/:folderId', redirect: to => {
    return `/folder-details/${to.params.folderId}`
  } },
  { path: '/terms-of-use', component: TermsOfUse, meta: { requiresAuth: true } },
  { path: '/termos-de-uso', redirect: '/terms-of-use' },
  { path: '/privacy-policy', component: PrivacyPolicies, meta: { requiresAuth: true } },
  { path: '/politica-de-privacidade', redirect: '/privacy-policy'},
  { path: '/loading', component: Loading, meta: { requiresAuth: true } },
  { path: '/my-team', component: MyTeam, meta: { requiresAuth: true }},
  { path: 'minha-equipe', redirect: '/my-team'},


  // Otherwise redirect to home
  { path: '*', redirect: '/login' }
];

// const routes = [
//   { path: '/login', component: Login, meta: { allowsLogin: true } },
//   { path: '/villafacil', component: LoginPartner, meta: { allowsLogin: true } },
//   { path: '/', component: Home, meta: { requiresAuth: true } },
//   { path: '/registro-de-ponto', component: newPoint, meta: { requiresAuth: true } },
//   { path: '/confirmacao-de-ponto', component: newConfirmPoint, meta: { requiresAuth: true } },
//   { path: '/historico-de-ponto', component: newPointHistory, meta: { requiresAuth: true } },
//   { path: '/minhas-solicitacoes', component: MeListFit, meta: { requiresAuth: true } },
//   { path: '/historico-de-log', component: LogHistory, meta: { requiresAuth: true } },
//   { path: '/detalhe-do-ponto/:idPoint/:type', component: DetailPoint, meta: { requiresAuth: true } },
//   { path: '/conversas', component: Chat, meta: { requiresAuth: true } },
//   { path: '/conversas/:idChat', component: Chat, meta: { requiresAuth: true } },
//   { path: '/comunicados', component: Communication, meta: { requiresAuth: true } },
//   { path: '/feedback', component: Feedback, meta: { requiresAuth: true } },
//   { path: '/detalhes-do-comunicado/:id', component: CommunicationDetail, meta: { requiresAuth: true } },
//   { path: '/meus-espelhos', component: MyMirror, meta: { requiresAuth: true } },
//   { path: '/saldo-de-horas', component: BalanceHours, meta: { requiresAuth: true } },
//   { path: '/perfil', component: Perfil, meta: { requiresAuth: true } },
//   { path: '/perfil/:routeB/:idUser', component: UserPerfil, meta: { requiresAuth: true } },
//   { path: '/detalhes-do-dia/:routeB/:idDay', component: DayDetail, meta: { requiresAuth: true } },
//   { path: '/gestao-de-ponto', component: PointControl, meta: { requiresAuth: true } },
//   { path: '/solicitar-ajuste/:idPoint/:type', component: RequestAdjustment, meta: { requiresAuth: true } },
//   { path: '/local-do-ponto', component: ShowLocationInMap, meta: { requiresAuth: true } },
//   { path: '/registro-de-pontos', component: AdminRegisterPoint, meta: { requiresAuth: true } },
//   { path: '/lista-de-solicitacao', component: ListFit, meta: { requiresAuth: true } },
//   { path: '/lista-de-ferias-afastamento', component: ListHoliday, meta: { requiresAuth: true } },
//   { path: '/gerenciar-ferias-afastamento', component: ListHolidayAdmin, meta: { requiresAuth: true } },
//   { path: '/solicitacao-de-ferias-afastamento', component: RequestHoliday, meta: { requiresAuth: true } },
//   { path: '/detalhes-da-ferias-afastamento/:idRequest', component: DetailHoliday, meta: { requiresAuth: true } },
//   { path: '/detalhes-da-ferias-afastamento/:idRequest/:returnType', component: DetailHoliday, meta: { requiresAuth: true } },
//   { path: '/verificar-ajuste-solicitado/:idSolicitation', component: RequestedFit, meta: { requiresAuth: true } },
//   { path: '/reembolsos', component: Refunds, meta: { requiresAuth: true } },
//   { path: '/documentos', component: Documents, meta: { requiresAuth: true } },
//   { path: '/detalhes-da-pasta/:folderId', component: FoldersDetail, meta: { requiresAuth: true } },
//   { path: '/loading', component: Loading, meta: { requiresAuth: true } },

//   accessToV2 ? { path: '/minha-equipe', props: () => (UTIL_SERVICE.checkLocationAndRedirectToV2(null, "minha-equipe")) } : { path: '/minha-equipe', component: MyTeam, meta: { requiresAuth: true } },

//   // Otherwise redirect to home
//   { path: '*', redirect: '/login' }
// ];

const router = new VueRouter({
  mode: 'history',
  routes
});

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    let authUser = JSON.parse(window.localStorage.getItem('authUser'));

    if (authUser && authUser.userToken && authUser.isAuth) {
      next()
    } else {
      next({ path: '/login' })
    }
  } else {
    if (to.meta.allowsLogin) {
      let authUser = JSON.parse(window.localStorage.getItem('authUser'));
      if (authUser && authUser.userToken && authUser.isAuth) {
        next({ path: '/registro-de-ponto' })
      } else {
        next()
      }
    }
  }
  next()
});

// export const app = new Vue({
//   el: '#app',
//   router,
//   i18n,
//   render: h => h(App),
//   mounted() {
//     document.dispatchEvent(new Event('render-event'))
//   },

// });


async function initApp() {
  await languageService.init()
  await initLocale.init()
  
  new Vue({
    el: '#app',
    router,
    i18n,
    render: h => h(App),
    mounted() {
      document.dispatchEvent(new Event('render-event'))
    },
  })
}

initApp()


// WEBPACK FOOTER //
// ./src/main.js